import React, { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';

import { EvSpinner } from '@evinced-private/ui-common';

import { RoutesHelper } from 'src/helpers/RoutesHelper';
import { IServerError } from 'src/interfaces/ServerError';
import { useNotifications } from 'src/providers/notificationsProvider/NotificationsConsumer';

import { usePropertyData } from './hooks/usePropertyData';
import { PropertySettingsEditor } from './PropertySettingsEditor';

export const PropertySettingsPageV2Inner: FC = () => {
	const { propertyId } = useParams<{ [key: string]: string }>();
	const history = useHistory();
	const notificationsContext = useNotifications();

	const { data, isLoading, error } = usePropertyData(propertyId);

	useEffect(() => {
		if (error) {
			notificationsContext.alert({
				serverError: error as unknown as IServerError,
				onOK: () => history.push(RoutesHelper.getPropertiesPagePath())
			});
		}
	}, [error, notificationsContext, history]);

	if (isLoading || !data) {
		return (
			<div className="spinner">
				<EvSpinner />
			</div>
		);
	}

	return (
		<PropertySettingsEditor
			key={propertyId}
			initialProperty={data.property}
			sourceMode={data.sourceMode}
			isNew={data.isNew}
			propertyId={propertyId}
		/>
	);
};
